import dayjs from "dayjs"
import { Record, RecordType } from "./Type"

export const BKASH_PAYMENT_LINK =
  "https://shop.bkash.com/bookkeeper01323867719/paymentlink"

/**
 * Find record type name based on its firestore ID
 * @param recTypeId
 * @param recordTypes
 * @returns
 */
export const getRecordType = (
  record: Record,
  recordTypes: RecordType[]
): RecordType => {
  // First, find recType based on name
  if (record.recordType && record.recordType !== "") {
    for (let recordType of recordTypes) {
      if (recordType.name === record.recordType) {
        return recordType
      }
    }
  }

  // No need to execute for loop below if id is empty in case of a new record
  if (record.recordTypeId === "") {
    if (recordTypes.length !== 0) {
      // send the first record type element
      return recordTypes[0]
    } else {
      console.warn("Empty RecordTypes!")
      return { id: "", name: "Unknown", insertDate: 0, lastEditDate: 0 }
    }
  }

  // Second, find recType based on id
  for (let recordType of recordTypes) {
    if (recordType.id === record.recordTypeId) {
      return recordType
    }
  }

  // Record type already deleted by user
  console.warn("Record type not found")
  return { id: "", name: "Unknown", insertDate: 0, lastEditDate: 0 }
}

/**
 * Find record type name based on its firestore ID
 * @param recTypeId
 * @param recordTypes
 * @returns
 */
export const getRecordTypeByName = (
  recTypeName: string,
  recordTypes: RecordType[]
): RecordType => {
  // No need to execute for loop below if id is empty
  if (recTypeName === "") {
    return { id: "", name: "unknown", insertDate: 0, lastEditDate: 0 }
  }

  for (let recordType of recordTypes) {
    if (recordType.name === recTypeName) {
      return recordType
    }
  }

  // Probably deleted by user
  return { id: "", name: "unknown", insertDate: 0, lastEditDate: 0 }
}

export const formatInvoiceNumber = (): string => {
  return `${dayjs().format("DDMMYYYY")}-${dayjs()
    .add(2, "week")
    .format("DDMMYYYY")}`
}

export const openInNewTab = (url: string) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer")
  if (newWindow) newWindow.opener = null
}
